<div class="image-container">
  <!-- Imports font awesome styles -->
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css"
        integrity="sha384-B4dIYHKNBt8Bc12p+WXckhzcICo0wtJAoU8YZTY5qE0Id1GSseTk6S+L3BlXeVIU"
        crossorigin="anonymous">
  <div>
    <div *ngIf="!hasImages" class="placeholder-image">
      <i class="far fa-images"></i>
    </div>
  </div>
  <app-rotation-image #rotationImage1 class="image"></app-rotation-image>
  <app-rotation-image #rotationImage2 class="image"></app-rotation-image>
  <app-rotation-image #rotationImage3 class="image"></app-rotation-image>
  <app-rotation-image #rotationImage4 class="image"></app-rotation-image>
  <app-rotation-image #rotationImage5 class="image"></app-rotation-image>
</div>
